import { request_for_startups_path } from "@routes/routes";
import { CommercialApplicationPageRequestForStartupsResponse } from "@tsTypes/index";
import {
  RequestForStartupForCard,
  RequestForStartupIndexResponse,
} from "@tsTypes/request_for_startups";
import { RequestForStartupMarketplaceFilterOptionsResponse } from "@tsTypes/request_for_startups/marketplace_filter_options";
import { RequestForStartupsShowResponse } from "@tsTypes/request_for_startups/show";
import { AxiosResponse } from "axios";
import api from "./request";

export const getMarketplaceRequestForStartups = async ({
  searchFilter,
  commercialApplicationsFilter,
}: {
  searchFilter: string;
  commercialApplicationsFilter: string[];
}): Promise<RequestForStartupForCard[]> => {
  const response: AxiosResponse<RequestForStartupIndexResponse> = await api.get(
    "/request_for_startups",
    {
      params: {
        options: {
          search_filter: searchFilter,
          commercial_applications_filter: commercialApplicationsFilter,
        },
      },
    }
  );
  return response.data.requests;
};

export const getMarketplaceRequestForStartupsFilterOptions =
  async (): Promise<RequestForStartupMarketplaceFilterOptionsResponse> => {
    const response = await api.get("/request_for_startup_marketplace_filter_options");
    return response.data;
  };

export const getCommercialApplicationPageRequestForStartups = async (
  commercialApplicationId: number,
  pageNum: number
): Promise<CommercialApplicationPageRequestForStartupsResponse> => {
  const response = await api.get(request_for_startups_path(), {
    params: {
      commercial_application_id: commercialApplicationId,
      page_num: pageNum,
    },
  });

  return response.data;
};

export const getRequestForStartup = async (
  slug: string
): Promise<RequestForStartupsShowResponse> => {
  const response = await api.get(`/request_for_startups/${slug}`);
  if (response.data.redirect) {
    window.location.href = response.data.redirect;
  }
  return response.data.request;
};
